import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  Box,
  CircularProgress,
  Typography
} from '@mui/material';
import axios from 'utils/axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const RoleCreate = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [role, setRole] = useState({
    name: '',
    code: '',
    managedRoles: [],
  });

  const [resolved, setResolved] = useState(null);
  const [valid, setValid] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [rolesResponse] = await Promise.all([
          axios.get('/api/roles'),
        ]);
        setResolved({
          roles: rolesResponse.data,
        });
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRole((prevRole) => ({
      ...prevRole,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    if (!valid) return;

    try {
      await axios.post('/users/role', role);
      toast.success(t('role_created'));
      navigate('/roles');
    } catch (error) {
      console.error('Error creating role:', error);
      toast.error(t('create_failed'));
    }
  };

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <Box sx={{ maxWidth: 600, margin: '0 auto', padding: 2 }}>
      <Box sx={{ marginBottom: 3 }}>
        <Typography variant="h5" component="h1">
          {t('create_new_role')}
        </Typography>
      </Box>

      <TextField
        label={t('name')}
        name="name"
        value={role.name}
        onChange={handleChange}
        fullWidth
        required
        margin="normal"
        helperText={t('required')}
      />
      <TextField
        label={t('code')}
        name="code"
        value={role.code}
        onChange={handleChange}
        fullWidth
        required
        margin="normal"
        helperText={t('required')}
      />

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 2 }}>
        <Button variant="outlined" onClick={() => navigate('/roles')} sx={{ marginRight: 2 }}>
          {t('cancel')}
        </Button>
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          {t('add')}
        </Button>
      </Box>
    </Box>
  );
};

export default RoleCreate;
